export enum ManualFilterOptions {
  ALL = 'ALL',
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
} 